import * as React from 'react';
import { Button } from '@/components/ui/Button';
import clsx from 'clsx';

interface DeleteRowProps {
  icon: string;
  title: string;
  description: string;
  buttonLabel: string;
  onAction: () => void;
  isLoading?: boolean;
}

/**
 * DeleteRow (Dumb Component)
 * Responsive Update: Stacks Icon -> Text -> Button (Full Width) on mobile.
 */
export const DeleteRow: React.FC<DeleteRowProps> = ({
  icon,
  title,
  description,
  buttonLabel,
  onAction,
  isLoading = false,
}) => (
  <div
    className={clsx(
      'relative mb-8 flex w-full',
      // Mobile: Column (Stack vertically)
      'flex-col gap-6',
      // Desktop: Row (Align horizontally, push apart)
      'md:flex-row md:items-center md:justify-between md:gap-6'
    )}
  >
    <div
      className={clsx(
        'flex min-w-0 flex-1',
        // Mobile: Column layout for Icon/Text
        'flex-col gap-3',
        // Desktop: Row layout for Icon/Text
        'md:flex-row md:items-start md:gap-4'
      )}
    >
      <img src={icon} alt='' className='mt-1 size-6 shrink-0 opacity-70' />
      <div className='flex flex-col'>
        <h4 className='font-sans text-20 font-medium leading-27 text-settings-delete-title'>
          {title}
        </h4>
        <p className='mt-1 font-sans text-16 font-normal leading-24 text-settings-delete-text'>
          {description}
        </p>
      </div>
    </div>

    <div
      className={clsx(
        'shrink-0',
        // Mobile: Full Width
        'w-full',
        // Desktop: Auto Width
        'md:w-auto'
      )}
    >
      <Button
        variant='settings-delete'
        className={clsx(
          'h-[36px]',
          // Mobile: Full Width
          'w-full',
          // Desktop: Fixed Width
          'md:w-[154px]'
        )}
        onClick={onAction}
        disabled={isLoading}
      >
        {isLoading ? 'Processing...' : buttonLabel}
      </Button>
    </div>
  </div>
);
